// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ActivityMonitorPagination_pagination__32_e1","paginationSpacer":"ActivityMonitorPagination_paginationSpacer__1pZZD"};